export default __webpack_public_path__ + "media/images/lp/icon1-365743c40535c7d96f881d0511e4fb9c.png";